import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Avatar from "react-avatar";
import { getAuth } from "../utils/Helper";
import { Logout } from "../utils/Logout";

const Sidebar: React.FC = () => {
  const dispatch = useDispatch<any>();
  const auth = getAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    Logout(navigate);
  };

  // helper function for active class
  const isActive = (path: string) => {
    return location.pathname === path ? "nav-link active" : "nav-link";
  };

  return (
    <div className="col-lg-3 mb-4">
      <div className="sidebar p-3">
        <div className="text-center mb-4">
          <Avatar
            name={auth?.name}
            size="85"
            round={true}
            color="#3568B2"
            fgColor="#fff"
          />
        </div>
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link className={isActive("/dashboard")} to="/dashboard">
              <i className="bi bi-person"></i> Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link className={isActive("/my-items")} to="/my-items">
              <i className="bi bi-book"></i> My Items
            </Link>
          </li>
          <li className="nav-item">
            <Link className={isActive("/my-orders")} to="/my-orders">
              <i className="bi bi-book"></i> My Orders
            </Link>
          </li>
          {/* <li className="nav-item">
            <Link className={isActive("/notifications")} to="/notifications">
              <i className="bi bi-bell"></i>
              Notifications
              <span className="badge bg-danger rounded-pill ms-1">3</span>
            </Link>
          </li> */}
          <li className="nav-item">
            <Link className={isActive("/settings")} to="/settings">
              <i className="bi bi-gear"></i> Settings
            </Link>
          </li>
          <li className="nav-item mt-3">
            <button className="nav-link text-danger" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right"></i> Sign Out
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
